// TODO - make removeAdditionalDriver and addAdditionalDriverByName use same casing for firstName and lastName props
import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

export const removeAdditionalDriver =
  ({ first_name, last_name, individual_id }) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        action: actions.request({
          service: services.gma.reservations.removeAdditionalDriver,
          data: {
            payload: {
              first_name,
              last_name,
              individual_id,
            },
          },
        }),
      })
    );
